// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#impulseTime{
    display:flex;
    justify-content: flex-start;
    width: fit-content;
    margin: auto;
}
#impulseTime select {
    outline: none;
    border: 2px solid rgba(20, 20, 20, .3);
    border-radius: 10px;
    padding: 0.35em .25em 0.35em .25em;
    font-weight: bold;
    color: rgb(50, 50, 60);
    box-shadow: 1px 1px 1px 1px rgba(50, 50, 50, .1);
    width: 25%;
    text-align: center;
    margin-top: .25em;
    width: fit-content;
}

#impulseTime input{
    margin-left:.5em;
    outline: none;
    padding: .25em;
    background: rgba(255,255,255,.1);
    width: 3em;
    border:0;
    box-shadow: 0 0 1px 1px rgba(100,100,100,.5);
    text-align: center;
  }

  #customImpulseTime{
    display:flex;
    justify-content: left;
    align-items: center;
    width: fit-content;
    column-gap: 2%;
  }

  #device-details-expiration-guest-date svg{
    font-size: 120%;
  }
  .loadingBox{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1em;
  }

  .device-details-guest{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
  }

  .device-details-guest > *{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    padding: 0 .25em;
  }
  .device-details-guest > h1{
    font-size: 110%;
  }
  .device-details-guest > div {
    border-bottom: 2px solid rgba(10,10,10,.3);
    margin-bottom: .5em;
  }
  .device-details-guest > div div{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .device-details-guest > div div:nth-child(2){
    width: 8em;
    justify-content: flex-start;
  }
  .device-details-guest > div div:nth-child(2) > svg, .device-details-guest > div div:nth-child(1) > svg {
    margin-right: .25em;
  }
  #device-details-expiration-guest-date{
    flex-direction: column;
  }
  .deactivated {
    color: rgba(50,50,50,.7);
  }

  #logs{
    height: 50vw;
    width: 100%;
    margin: auto;
    overflow: scroll;
    background: rgb(0,0,0);
    color: rgb(255,255,255);
    padding: 1em;
    border-radius:8px;
    border: 0;
    margin-bottom: 3em;
    text-align: left;
  }

  #logs-title{
    font-weight:bold;
    font-size:110%;
    border-top: 1px dashed black;
    width: 100%;
    text-align: center;
    color: rgb(0,0,0);
    margin-top: .5em;
    padding: .5em;
  }

  #device-openType-container{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 1em;
    border-top: 1px dashed black;
    padding-top: .5em;
  }
  .device-openType h2 {
    font-size: 110%;
    font-weight: bold;
    margin:0;
    padding:0;
    margin-bottom: .25em;
  }
  #device-openType-container button{
    border-radius: 8px;
  }
  #device-openType-container-btns{
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 5px;
  }
  #device-openType-container-impulseMode{
    margin-top: 1em;
  }
  #device-openType-container-impulseTime{
    margin-top: 1em;
  }`, "",{"version":3,"sources":["webpack://./css/device.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sCAAsC;IACtC,mBAAmB;IACnB,kCAAkC;IAClC,iBAAiB;IACjB,sBAAsB;IACtB,gDAAgD;IAChD,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,UAAU;IACV,QAAQ;IACR,4CAA4C;IAC5C,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,0CAA0C;IAC1C,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,4BAA4B;IAC5B,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,QAAQ;IACR,SAAS;IACT,oBAAoB;EACtB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB","sourcesContent":["#impulseTime{\n    display:flex;\n    justify-content: flex-start;\n    width: fit-content;\n    margin: auto;\n}\n#impulseTime select {\n    outline: none;\n    border: 2px solid rgba(20, 20, 20, .3);\n    border-radius: 10px;\n    padding: 0.35em .25em 0.35em .25em;\n    font-weight: bold;\n    color: rgb(50, 50, 60);\n    box-shadow: 1px 1px 1px 1px rgba(50, 50, 50, .1);\n    width: 25%;\n    text-align: center;\n    margin-top: .25em;\n    width: fit-content;\n}\n\n#impulseTime input{\n    margin-left:.5em;\n    outline: none;\n    padding: .25em;\n    background: rgba(255,255,255,.1);\n    width: 3em;\n    border:0;\n    box-shadow: 0 0 1px 1px rgba(100,100,100,.5);\n    text-align: center;\n  }\n\n  #customImpulseTime{\n    display:flex;\n    justify-content: left;\n    align-items: center;\n    width: fit-content;\n    column-gap: 2%;\n  }\n\n  #device-details-expiration-guest-date svg{\n    font-size: 120%;\n  }\n  .loadingBox{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 1em;\n  }\n\n  .device-details-guest{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .device-details-guest > *{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0;\n    padding: 0 .25em;\n  }\n  .device-details-guest > h1{\n    font-size: 110%;\n  }\n  .device-details-guest > div {\n    border-bottom: 2px solid rgba(10,10,10,.3);\n    margin-bottom: .5em;\n  }\n  .device-details-guest > div div{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .device-details-guest > div div:nth-child(2){\n    width: 8em;\n    justify-content: flex-start;\n  }\n  .device-details-guest > div div:nth-child(2) > svg, .device-details-guest > div div:nth-child(1) > svg {\n    margin-right: .25em;\n  }\n  #device-details-expiration-guest-date{\n    flex-direction: column;\n  }\n  .deactivated {\n    color: rgba(50,50,50,.7);\n  }\n\n  #logs{\n    height: 50vw;\n    width: 100%;\n    margin: auto;\n    overflow: scroll;\n    background: rgb(0,0,0);\n    color: rgb(255,255,255);\n    padding: 1em;\n    border-radius:8px;\n    border: 0;\n    margin-bottom: 3em;\n    text-align: left;\n  }\n\n  #logs-title{\n    font-weight:bold;\n    font-size:110%;\n    border-top: 1px dashed black;\n    width: 100%;\n    text-align: center;\n    color: rgb(0,0,0);\n    margin-top: .5em;\n    padding: .5em;\n  }\n\n  #device-openType-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    margin-top: 1em;\n    border-top: 1px dashed black;\n    padding-top: .5em;\n  }\n  .device-openType h2 {\n    font-size: 110%;\n    font-weight: bold;\n    margin:0;\n    padding:0;\n    margin-bottom: .25em;\n  }\n  #device-openType-container button{\n    border-radius: 8px;\n  }\n  #device-openType-container-btns{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    column-gap: 5px;\n  }\n  #device-openType-container-impulseMode{\n    margin-top: 1em;\n  }\n  #device-openType-container-impulseTime{\n    margin-top: 1em;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
